import { apiClient } from '@/services/base'

import { ISendCodeResetMultiTenantRequest } from './interfaces/request'
import {
  ISendCodeResetMultiTenantResponse,
  ISendCodeResetMultiTenantErrorResponse,
} from './interfaces/response'

export const SendCodeResetMultiTenantService = async (
  request: ISendCodeResetMultiTenantRequest,
): Promise<ISendCodeResetMultiTenantResponse> => {
  const response = await apiClient.post(
    'api/PasswordReset/MultiTenant',
    {},
    {
      params: request,
    },
  )

  return response
}

export type {
  ISendCodeResetMultiTenantRequest,
  ISendCodeResetMultiTenantResponse,
  ISendCodeResetMultiTenantErrorResponse,
}
